import { ChangeDetectionStrategy, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { forEach } from 'lodash';

/**
 * Service that counts all component instances on page and print it in console.
 * To run type componentCounterService.parseComponents() in console.
 */
@Injectable()
export class ComponentCounterService {
  public constructor(@Inject(DOCUMENT) private document: Document) {}

  public injectInWindow(): void {
    window['componentCounterService'] = this;
  }

  public parseComponents(): void {
    const store = new Map<string, { count: number; isOnPush?: boolean }>();
    const body = this.document.body;
    this.countComponents(body, store);
  }

  protected countComponents(
    element: HTMLElement,
    store: Map<string, { count: number; isOnPush?: boolean }>,
  ): void {
    const component = (<any>window).ng.getComponent(element);

    if (component) {
      const name: string = element.localName;
      if (store.has(name)) {
        store.get(name).count += 1;
      } else {
        const strategy =
          component.constructor.__annotations__?.[0].changeDetection;
        store.set(name, {
          count: 1,
          isOnPush:
            strategy !== undefined
              ? strategy === ChangeDetectionStrategy.OnPush
              : undefined,
        });
      }
    }

    if (element.children) {
      forEach(element.children, (child: HTMLElement) =>
        this.countComponents(child, store),
      );
    }
  }
}
